import { render } from "./InstaWrapperView.vue?vue&type=template&id=03f0b9c2&ts=true"
import script from "./InstaWrapperView.vue?vue&type=script&lang=ts"
export * from "./InstaWrapperView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__